export const keys = {
    collections: {
        all: () => ['collections'] as const,
        detail: (id: string) => ['collections', id] as const,
        public: (token: string) => ['collections', 'public', token] as const,
    },
    folders: {
        all: () => ['folders'] as const,
        detail: (id: string) => ['folders', id] as const,
    },
    picks: {
        all: () => ['picks'] as const,
        context: (context: string) => ['picks', { context }] as const, // 'home', 'collection_123', 'folder_123'
        detail: (id: string) => ['picks', 'detail', id] as const,
        stats: () => ['picks', 'stats'] as const,
    },
    library: {
        status: () => ['library', 'status'] as const,
    },
    hashtags: {
        all: () => ['hashtags'] as const,
    },
}
